import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";
import { createLogSession } from "../restful/logs/logs";

const GET_USER_PREFERENCE_NAVIGATION = gql`
    query getUserPreferenceNavigation($userid:String) {
        getUserPreferenceNavigation(userid:$userid) {
            ... on UserPreferenceNavigation {
                webNavigation{
                    moduleId{
                        id
                        _id
                        name
                        categoryName
                        isEnabled
                        isEditable
                    }
                    position
                    isLocked
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getUserPreferenceNavigation(userid) {

    const variables = {
        userid: userid,
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_USER_PREFERENCE_NAVIGATION, variables, false);
    return execute;
}

const UPDATE_USER_PREFERENCE_NAVIGATION = gql`
    mutation updateUserPreferenceNavigation($input: UserPreferenceNavigationInput) {
        updateUserPreferenceNavigation(input: $input){
            ... on UserPreferenceNavigation {
                webNavigation{
                    moduleId{
                        id
                        name
#                        parent{
#                            id
#                            name
#                            isEnabled
#                            isEditable
#                        }
                        isEnabled
                        isEditable
                    }
                    position
                    isLocked
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function updateWebModuleSetting(userid, webNavigation) {
    const session = createLogSession("User", "ModuleSetting", "updateWebModuleSetting");
    session.create({ description: "Updating module setting", logData: { userid, webNavigation } });

    const variables = {
        input: {
            user: userid,
            webNavigation: webNavigation
        },
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };

    try {
        const execute = await ApolloClientQuery(UPDATE_USER_PREFERENCE_NAVIGATION, variables, true);
        const err = execute?.updateUserPreferenceNavigation?.__typename === "BaseError" ? execute?.updateUserPreferenceNavigation : null;
        session.create({ description: err ? "Module setting update failed" : "Module setting updated", status: err ? "error" : "info", logData: err ? { error: err, userid, webNavigation } : { userid, webNavigation } });
        return execute;
    } catch (e) {
        session.create({ description: "Module setting update failed", status: "error", logData: { userid, webNavigation, error: e } });
        throw e;
    }
}

const GET_MODULE_SETTING = gql`
    query getModuleSetting($filter:ModuleSettingSearchInput) {
        getModuleSetting(filter:$filter) {
            ... on ModuleSettingArray {
                data{
                    id
                    _id
                   name
                   categoryName
                    parent{
                        _id
                        id
                        name
                        isEnabled
                    }
                    categoryName
                    isEnabled
                    iconLightActive{
                        path
                    }
                    defaultIconDarkActive {
                        path
                    }
                    defaultIconDarkInactive {
                        path
                    }
                    defaultIconLightActive {
                        path
                    }
                    defaultIconLightInactive {
                        path
                    }
                    description
                    iconDarkActive {
                        path
                    }
                    iconDarkInactive {
                        path
                    }
                    iconLightActive {
                        path
                    }
                    iconLightInactive {
                        path
                    }
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getModuleSetting() {

    const variables = {
        // filter: {
        //     layout: "2"
        // },
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_MODULE_SETTING, variables, false);

    return execute;
}

const GET_DEFAULT_WEB_MODULE_SETTING = gql`
   query getWebModuleSetting{
        getWebModuleSetting(filter:{hasPosition: true,moduleName: ""}){
            ... on WebModuleSettingArray {
                data {
                    position
                    _id
                    isLocked
                    moduleId {
                        _id
                        name
                    }
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getDefaultWebModuleSetting() {

    const variables = {
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_DEFAULT_WEB_MODULE_SETTING, variables, false);

    return execute;
}

